/**
 * Created by wzf on 2018/4/23.
 */
export const m = {
    b_newrole: '新增角色',
    t_deleterole: '删除角色',
    t_updaterole: '編輯角色',
    m_newsucs: '新增成功',
    m_deletesuc: '删除成功',
    m_info: '信息提示',
    m_accountnumber: '請輸入账号',
    m_length220: '长度在 2 到 20 个字符',
    m_deleterole: '此操作將永久刪除該角色, 是否繼續?',
    m_jurisdiction: '請至少選擇一种权限',
    m_updatesucs:'修改成功',
    t_confirm:'確認',
    t_cancel:'取消',
    t_search: '搜索條件',
    t_custcode: '客戶編號',
    t_groupname: '組名',
    t_customergroupname: '客戶組名',
    b_breakrelation: '解除關系',
    b_newmembergrp: '新增客戶組成員',
    m_groupnameinput: '請輸入客戶組名',
    m_customerinput: '請輸入客戶',
    m_deleteconfirmnexus: '此操作将解除与客戶组的关系, 是否继续?',
    m_removesuc: '关系解除成功',
    t_memberdata: '成員資料',
    m_newmembersuc: '添加成员成功',
    t_memebername: '成員名字',
    b_query: '查詢',
    b_opt: '操作',
    b_edit: '編輯',
    t_nodata: '暫無數據',
    t_customergroup: '客戶组管理',
    t_newcustomergroup: '新增客戶組',
    t_updatecustomergroup: '編輯客戶組',
    t_deletecustomergroup: '刪除客戶組',
    t_customergroupsee: '客戶組詳情',
    t_newproductcode: '新增客戶产品编码',
    t_updateproductcode: '編輯客戶产品编码',
    t_deletecustproductc: '删除客戶产品编码',
    b_cancel: '取消',
    b_save: '保存',
    m_newsucs: '新增成功',
    m_updatesucs: '修改成功',
    m_deleteconfirm: '此操作將永久刪除該資料, 是否繼續？',
    m_deletesuc: '删除成功',
    t_customer: '客戶',
    s_login: '用戶名/別名',
    t_login: '用戶名',
    t_enable: '啟用',
    t_stop: '停用',
    t_newTask: '新增任务',
    t_salesName:'銷售員',
    t_taskDate:'任务時間',
    t_booking:'搬迁预订',
    t_site:'现场调查',
    t_delete:'删除',
    t_selectthefile: '選擇檔案',
    t_enclosureadmin: '附件管理',
    b_uploadfile: '上傳文件',
    b_uploadfileMaxFiftyMb:'上傳文件不能超过50MB',
    m_uploadsuccess: '上傳成功',
    t_filename: '文件名',
    t_filenameremark: '文件備註',
    t_uploadby: '上傳人',
    t_uploadtime: '上傳時間',
    t_remarks: '備註',
    t_file: '文件',
    t_download: '下载',
    b_delete: '删除',
    menu_task: '任務資料',
    t_export: "導出",
    t_lastweek: '最近一周',
    t_lastmonth: '最近一个月',
    t_lastthreemonth: '最近三个月',
    m_accounting: '會計',
    menu_cust: '客戶報表',
    menu_storIn: '入倉報表',
    menu_storOn:'出倉報表',
    menu_storInOn:'出入倉紀錄表',
    menu_existing:'貨倉現存報表',
    menu_jobNo: '工作單號',
    t_date: '日期',
    t_startdate: '开始日期',
    t_enddate: '结束日期',
    t_quarterDate: '季度',
    t_monthDate: '月份',
    t_yearDate: '年份',
    m_date: '請選擇季度',
    m_monthDate: '請選擇月份',
    m_yearDate: '請選擇年份',
    m_customer: '請選擇客戶',
    t_newFeedBack:'新增回料',
    t_newRolling:'新增出倉',
    m_numbernot0: '数量不能少于0!',
    t_addgoodsadjustment: '新增货品调整',
    t_editgoodsadjustment: '修改货品调整',
    t_qtysk: '数量',
    b_prodcode: '产品',
    t_nodata: '暫無數據',
    t_new: '新增',
    m_untreated: '该产品已存在，还未处理',
    m_repeatedselection: '重复選擇产品',
    m_productchoice: '請選擇产品',
    m_number: '請輸入数量',
    m_remarks: '請輸入備註',
    m_newgoodssuc: '新增货品成功',
    m_lengthmin100: '长度不超过100位',
    m_producttype: '請選擇产品',
    b_import: '导入',
    b_delete: '删除',
    m_deleteconfirm: '此操作將永久刪除該資料, 是否繼續？',
    m_deletesuc: '删除成功',
    m_Importconfirm: '你確定要入倉嗎？',
    m_outconfirm: '你確定要出倉嗎？',
    m_Importsucs:'导入成功',
    t_ExportFormat:'導出格式',
    t_place:'地點',
    m_pleaseSalesName:'請選擇銷售員',
    m_pleasePlace:'請選擇地點',
    m_pleaseStartdate: '請選擇開始時間',
    m_pleaseEnddate: '請選擇結束時間',
    t_calendarStartdate: '開始時間',
    t_calendarEnddate: '結束時間',
    m_startmaxenddate: '開始時間不能大于結束時間',
    m_endminstartdate: '結束時間不能小于開始時間',
    t_downloadPDF: 'PDF下载',
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js